module.exports = __webpack_public_path__ + "static/media/loc1_img9.dd7d3d97.jpg";